import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { LegalSection } from "@/components/legal/LegalSection";

const tableOfContents = [
  { id: "chap-nhan-dieu-khoan", title: "Chấp nhận Điều khoản", level: 1 },
  { id: "mo-ta-dich-vu", title: "Mô tả Dịch vụ", level: 1 },
  {
    id: "dich-vu-khan-cap",
    title: "Dịch vụ Khẩn cấp và Tính năng Định vị",
    level: 1,
  },
  {
    id: "dieu-kien-tham-gia",
    title: "Điều kiện tham gia và Đăng ký",
    level: 1,
  },
  {
    id: "hanh-vi-nguoi-dung",
    title: "Hành vi và trách nhiệm của người dùng",
    level: 1,
  },
  {
    id: "chinh-sach-noi-dung",
    title: "Nội dung và nguyên tắc cộng đồng",
    level: 1,
  },
  { id: "quyen-so-huu-tri-tue", title: "Quyền sở hữu trí tuệ", level: 1 },
  { id: "bao-mat", title: "Quyền riêng tư và bảo vệ dữ liệu", level: 1 },
  { id: "hoat-dong-cam", title: "Hoạt động bị cấm", level: 1 },
  { id: "cham-dut-tai-khoan", title: "Chấm dứt tài khoản", level: 1 },
  {
    id: "tuyen-bo-va-han-che",
    title: "Tuyên bố và hạn chế trách nhiệm",
    level: 1,
  },
  { id: "boi-thuong", title: "Bồi thường", level: 1 },
  {
    id: "luat-ap-dung",
    title: "Luật áp dụng và giải quyết tranh chấp",
    level: 1,
  },
  { id: "thay-doi-dieu-khoan", title: "Thay đổi Điều khoản", level: 1 },
  { id: "lien-he", title: "Thông tin liên hệ", level: 1 },
];

export default function TermsOfServiceVietnamese() {
  return (
    <LegalPageLayout
      title="Điều khoản Dịch vụ"
      lastUpdated="6 tháng 1, 2025"
      language="vi"
      alternateUrl="/pages/terms"
      tableOfContents={tableOfContents}
    >
      <LegalSection id="chap-nhan-dieu-khoan" title="Chấp nhận Điều khoản">
        <p>
          Chào mừng bạn đến với Locuno! Điều khoản Dịch vụ này ("Điều khoản")
          tạo thành một thỏa thuận ràng buộc pháp lý giữa bạn và Cloudjet
          Solutions Pte. Ltd. ("Locuno," "chúng tôi," "của chúng tôi") điều
          chỉnh việc bạn sử dụng nền tảng mạng xã hội Locuno, bao gồm trang web,
          ứng dụng di động và tất cả các dịch vụ liên quan (gọi chung là "Dịch
          vụ").
        </p>
        <p>
          Bằng việc truy cập, duyệt hoặc sử dụng Dịch vụ của chúng tôi, bạn xác
          nhận rằng bạn đã đọc, hiểu và đồng ý bị ràng buộc bởi các Điều khoản
          này và{" "}
          <a href="/pages/vi/privacy" className="text-blue-600 hover:underline">
            Chính sách Bảo mật
          </a>{" "}
          của chúng tôi. Nếu bạn không đồng ý với các Điều khoản này, bạn không
          được sử dụng Dịch vụ của chúng tôi.
        </p>
        <p>
          Các Điều khoản này áp dụng cho tất cả người dùng Dịch vụ của chúng
          tôi, bao gồm khách truy cập, người dùng đã đăng ký, người tạo nội dung
          và tài khoản doanh nghiệp.
        </p>
      </LegalSection>

      <LegalSection id="mo-ta-dich-vu" title="Mô tả Dịch vụ">
        <p>
          Locuno là một nền tảng mạng xã hội kết nối mọi người trong các cộng
          đồng địa phương. Dịch vụ của chúng tôi cho phép người dùng:
        </p>
        <ul>
          <li>
            Tạo hồ sơ và kết nối với bạn bè, hàng xóm và thành viên cộng đồng
            địa phương
          </li>
          <li>
            Chia sẻ nội dung bao gồm bài đăng văn bản, ảnh, video và cập nhật
            dựa trên vị trí
          </li>
          <li>
            Khám phá và tham gia các sự kiện, nhóm và hoạt động địa phương
          </li>
          <li>
            Tìm và giới thiệu doanh nghiệp, dịch vụ và địa điểm đáng quan tâm
            địa phương
          </li>
          <li>Mua bán các mặt hàng trong thị trường địa phương</li>
          <li>Giao tiếp thông qua nhắn tin, bình luận và thảo luận nhóm</li>
          <li>
            Truy cập các tính năng dựa trên vị trí và nội dung cụ thể của cộng
            đồng
          </li>
        </ul>
        <p>
          Chúng tôi bảo lưu quyền sửa đổi, tạm ngừng hoặc ngừng bất kỳ phần nào
          của Dịch vụ bất cứ lúc nào, có hoặc không có thông báo. Chúng tôi cũng
          có thể áp đặt giới hạn đối với một số tính năng hoặc hạn chế truy cập
          vào các phần của Dịch vụ mà không có thông báo hoặc trách nhiệm pháp
          lý.
        </p>
      </LegalSection>

      <LegalSection
        id="dich-vu-khan-cap"
        title="Dịch vụ Khẩn cấp và Tính năng Định vị"
      >
        <h3>Tuyên bố EULA về Dịch vụ Khẩn cấp và Cảnh báo dựa trên Vị trí</h3>
        <p>
          <strong>
            DỊCH VỤ NÀY KHÔNG PHẢI LÀ THAY THẾ CHO 911 HOẶC CÁC DỊCH VỤ KHẨN CẤP
            CÔNG CỘNG.
          </strong>
        </p>
        <p>
          Locuno là một công cụ mạng lưới an toàn cá nhân. Tính năng "SOS" được
          thiết kế để cảnh báo và kết nối bạn với các liên hệ đáng tin cậy được
          chọn trước của riêng bạn ("Người phản ứng," ví dụ: gia đình, bạn bè,
          hàng xóm) thông qua Voice over IP (VoIP), video và chia sẻ vị trí thời
          gian thực.
        </p>
        <p>Bạn, người dùng, xác nhận và đồng ý với các điều sau:</p>

        <h4>Không kết nối với Dịch vụ Công cộng</h4>
        <p>
          Ứng dụng không kết nối, điều phái hoặc giao tiếp với bất kỳ dịch vụ
          khẩn cấp công cộng, người phản ứng đầu tiên hoặc điểm trả lời an toàn
          công cộng (PSAPs) nào, chẳng hạn như 911, 999 hoặc 112. Kích hoạt tính
          năng SOS sẽ không dẫn đến việc cảnh sát, cứu hỏa hoặc dịch vụ y tế
          được tự động điều phái.
        </p>

        <h4>Trách nhiệm của Người dùng</h4>
        <p>
          Trong trường hợp khẩn cấp nghiêm trọng, bạn nên liên hệ trực tiếp với
          các dịch vụ khẩn cấp công cộng thông qua các phương tiện truyền thống
          (ví dụ: bằng cách gọi 911). Bạn không nên dựa vào Locuno như phương
          pháp chính để liên hệ trợ giúp khẩn cấp trong các tình huống đe dọa
          tính mạng.
        </p>

        <h4>Phụ thuộc vào Mạng lưới Cá nhân</h4>
        <p>
          Hiệu quả của tính năng SOS hoàn toàn phụ thuộc vào việc Người phản ứng
          được chọn của bạn có sẵn, sẵn lòng và có khả năng nhận cảnh báo và
          cung cấp hỗ trợ. Chúng tôi không đảm bảo rằng Người phản ứng của bạn
          sẽ nhận được cảnh báo hoặc phản ứng.
        </p>

        <h4>Chia sẻ Vị trí</h4>
        <p>
          Bằng cách kích hoạt tính năng SOS, bạn đồng ý chia sẻ dữ liệu vị trí
          thời gian thực của mình với Người phản ứng được chỉ định trong thời
          gian cảnh báo. Mục đích của điều này là cho phép mạng lưới cá nhân của
          bạn xác định vị trí của bạn và cung cấp hỗ trợ. Locuno không và không
          thể xác minh thông tin vị trí được Người phản ứng của bạn nhận.
        </p>

        <h3>Cách thức hoạt động của Tính năng SOS</h3>
        <p>
          Khi bạn bật dịch vụ định vị và kích hoạt tính năng SOS trong ứng dụng:
        </p>
        <ul>
          <li>
            <strong>Cuộc gọi VoIP/Video:</strong> Ứng dụng khởi tạo cuộc gọi
            Voice over IP (VoIP) hoặc cuộc gọi video với các liên hệ đáng tin
            cậy được chọn trước của bạn (Người phản ứng)
          </li>
          <li>
            <strong>Chia sẻ Vị trí:</strong> Vị trí thời gian thực của bạn chỉ
            được chia sẻ với Người phản ứng được chỉ định trong mạng lưới Locuno
          </li>
          <li>
            <strong>Cảnh báo Mạng lưới Cá nhân:</strong> Các liên hệ đáng tin
            cậy của bạn nhận thông báo trong ứng dụng và có thể xem vị trí của
            bạn để cung cấp hỗ trợ
          </li>
          <li>
            <strong>Giao tiếp Ngang hàng:</strong> Tất cả giao tiếp diễn ra trực
            tiếp giữa bạn và mạng lưới cá nhân của bạn, không thông qua bất kỳ
            hệ thống điều phái khẩn cấp công cộng nào
          </li>
        </ul>

        <h3>Giới hạn Dịch vụ</h3>
        <p>
          <strong>GIỚI HẠN QUAN TRỌNG:</strong>
        </p>
        <ul>
          <li>
            <strong>Không phải Thay thế cho 911:</strong> Tính năng SOS KHÔNG
            phải là thay thế cho việc gọi các dịch vụ khẩn cấp chính thức (911,
            112, v.v.)
          </li>
          <li>
            <strong>Không kết nối với Dịch vụ Khẩn cấp Công cộng:</strong> Chúng
            tôi không kết nối, tích hợp hoặc truyền dữ liệu đến bất kỳ dịch vụ
            khẩn cấp công cộng, người phản ứng đầu tiên hoặc PSAP nào
          </li>
          <li>
            <strong>Phụ thuộc vào Mạng lưới của Bạn:</strong> Hiệu quả phụ thuộc
            hoàn toàn vào việc Người phản ứng của bạn có sẵn, sẵn lòng và có khả
            năng giúp đỡ
          </li>
          <li>
            <strong>Giới hạn Kỹ thuật:</strong> Tính khả dụng dịch vụ phụ thuộc
            vào kết nối internet, tín hiệu GPS, chức năng thiết bị và việc Người
            phản ứng của bạn có cài đặt và kích hoạt ứng dụng
          </li>
          <li>
            <strong>Trách nhiệm Người dùng:</strong> Bạn vẫn chịu trách nhiệm
            duy nhất trong việc liên hệ trực tiếp với các dịch vụ khẩn cấp công
            cộng (911, 112, v.v.) cho các tình huống đe dọa tính mạng
          </li>
          <li>
            <strong>Không Đảm bảo Phản ứng:</strong> Chúng tôi không thể đảm bảo
            rằng Người phản ứng của bạn sẽ nhận được cảnh báo, phản ứng hoặc
            cung cấp hỗ trợ
          </li>
        </ul>

        <h3>Xác nhận của Người dùng</h3>
        <p>
          Bằng việc sử dụng các tính năng SOS và định vị của Locuno, bạn xác
          nhận và đồng ý rằng:
        </p>
        <ul>
          <li>
            Bạn hiểu đây là mạng lưới an toàn cá nhân ngang hàng, không phải
            dịch vụ phản ứng khẩn cấp
          </li>
          <li>
            Bạn sẽ luôn liên hệ trực tiếp với các dịch vụ khẩn cấp chính thức
            (911, 112, v.v.) cho các tình huống đe dọa tính mạng
          </li>
          <li>
            Bạn đồng ý chia sẻ dữ liệu vị trí của mình với Người phản ứng được
            chỉ định trong mạng lưới Locuno
          </li>
          <li>
            Bạn hiểu ứng dụng không kết nối với bất kỳ dịch vụ khẩn cấp công
            cộng hoặc hệ thống điều phái nào
          </li>
          <li>
            Bạn sẽ không dựa vào Locuno một cách duy nhất để được hỗ trợ khẩn
            cấp
          </li>
          <li>
            Người phản ứng của bạn có thể chọn liên hệ với các dịch vụ khẩn cấp
            công cộng thay mặt bạn nếu họ xác định là cần thiết
          </li>
        </ul>
      </LegalSection>

      <LegalSection
        id="dieu-kien-tham-gia"
        title="Điều kiện tham gia và Đăng ký"
      >
        <h3>Yêu cầu về độ tuổi</h3>
        <p>
          Bạn phải từ 13 tuổi trở lên để sử dụng Dịch vụ của chúng tôi. Nếu bạn
          dưới 18 tuổi, bạn tuyên bố rằng bạn đã được cha mẹ hoặc người giám hộ
          đồng ý sử dụng Dịch vụ của chúng tôi.
        </p>

        <h3>Đăng ký tài khoản</h3>
        <p>
          Để sử dụng một số tính năng của Dịch vụ, bạn phải đăng ký tài khoản.
          Khi đăng ký, bạn đồng ý:
        </p>
        <ul>
          <li>Cung cấp thông tin chính xác, hiện tại và đầy đủ</li>
          <li>Duy trì và kịp thời cập nhật thông tin tài khoản của bạn</li>
          <li>Giữ mật khẩu của bạn an toàn và bí mật</li>
          <li>
            Chấp nhận trách nhiệm cho tất cả hoạt động dưới tài khoản của bạn
          </li>
          <li>
            Thông báo ngay cho chúng tôi về bất kỳ việc truy cập trái phép hoặc
            vi phạm bảo mật nào
          </li>
        </ul>

        <h3>Một tài khoản mỗi người</h3>
        <p>
          Bạn chỉ có thể tạo một tài khoản cho mỗi người. Việc tạo nhiều tài
          khoản hoặc mạo danh người khác bị cấm và có thể dẫn đến việc chấm dứt
          tài khoản.
        </p>

        <h3>Hạn chế địa lý</h3>
        <p>
          Dịch vụ của chúng tôi dành cho người dùng tại các khu vực mà chúng có
          sẵn hợp pháp. Bạn có trách nhiệm tuân thủ luật pháp và quy định địa
          phương trong khu vực tài phán của mình.
        </p>
      </LegalSection>

      <LegalSection
        id="hanh-vi-nguoi-dung"
        title="Hành vi và trách nhiệm của người dùng"
      >
        <p>Là người dùng Dịch vụ của chúng tôi, bạn đồng ý:</p>
        <ul>
          <li>Sử dụng Dịch vụ tuân thủ tất cả luật pháp và quy định áp dụng</li>
          <li>Tôn trọng quyền và phẩm giá của người dùng khác</li>
          <li>
            Cung cấp thông tin chính xác và không xuyên tạc danh tính của bạn
          </li>
          <li>
            Duy trì tính bảo mật và bí mật của thông tin đăng nhập tài khoản
          </li>
          <li>
            Báo cáo các vi phạm Điều khoản này hoặc hoạt động bất hợp pháp cho
            chúng tôi
          </li>
          <li>Tôn trọng quyền sở hữu trí tuệ của người khác</li>
          <li>Chỉ sử dụng Dịch vụ cho mục đích dự định</li>
        </ul>

        <h3>Tiêu chuẩn cộng đồng</h3>
        <p>
          Locuno được xây dựng dựa trên nguyên tắc tạo ra các cộng đồng địa
          phương an toàn và chào đón. Chúng tôi mong đợi tất cả người dùng đóng
          góp tích cực vào môi trường này bằng cách đối xử với người khác một
          cách tôn trọng và tuân theo hướng dẫn cộng đồng của chúng tôi.
        </p>

        <h3>Nội dung do người dùng tạo</h3>
        <p>
          Bạn hoàn toàn chịu trách nhiệm về bất kỳ nội dung nào bạn đăng, chia
          sẻ hoặc truyền tải qua Dịch vụ của chúng tôi. Điều này bao gồm việc
          đảm bảo bạn có tất cả các quyền và sự cho phép cần thiết cho nội dung
          bạn chia sẻ.
        </p>
      </LegalSection>

      <LegalSection
        id="chinh-sach-noi-dung"
        title="Nội dung và nguyên tắc cộng đồng"
      >
        <h3>Nội dung được chấp nhận</h3>
        <p>Khi sử dụng Dịch vụ của chúng tôi, bạn có thể đăng nội dung:</p>
        <ul>
          <li>Tôn trọng và mang tính xây dựng</li>
          <li>Liên quan đến cộng đồng địa phương và sở thích</li>
          <li>Nguyên bản hoặc được ghi nguồn đúng cách</li>
          <li>Tuân thủ luật pháp áp dụng</li>
          <li>Phù hợp với mọi lứa tuổi (khi ở khu vực công cộng)</li>
        </ul>

        <h3>Nội dung bị cấm</h3>
        <p>Bạn không được đăng, chia sẻ hoặc truyền tải nội dung:</p>
        <ul>
          <li>
            Bất hợp pháp, có hại, đe dọa hoặc khuyến khích hoạt động bất hợp
            pháp
          </li>
          <li>Chứa lời nói thù hận, phân biệt đối xử hoặc quấy rối</li>
          <li>Có tính chất khiêu dâm, khiêu gợi hoặc không phù hợp</li>
          <li>Vi phạm quyền sở hữu trí tuệ</li>
          <li>Chứa thông tin sai lệch, gây hiểu lầm hoặc lừa dối</li>
          <li>Khuyến khích bạo lực, tự gây tổn hại hoặc hoạt động nguy hiểm</li>
          <li>Bao gồm spam, phần mềm độc hại hoặc nỗ lực lừa đảo</li>
          <li>Vi phạm quyền riêng tư hoặc chứa thông tin cá nhân trái phép</li>
          <li>Có ý định thao túng hoặc lừa dối người dùng khác</li>
        </ul>

        <h3>Điều hành nội dung</h3>
        <p>
          Chúng tôi bảo lưu quyền xem xét, điều hành, chỉnh sửa hoặc xóa bất kỳ
          nội dung nào vi phạm Điều khoản này hoặc hướng dẫn cộng đồng của chúng
          tôi. Chúng tôi cũng có thể hạn chế hoặc chấm dứt tài khoản liên tục vi
          phạm chính sách của chúng tôi.
        </p>

        <h3>Báo cáo vi phạm</h3>
        <p>
          Người dùng có thể báo cáo nội dung hoặc hành vi vi phạm Điều khoản của
          chúng tôi thông qua các cơ chế báo cáo. Chúng tôi điều tra tất cả báo
          cáo và thực hiện hành động thích hợp khi vi phạm được xác nhận.
        </p>
      </LegalSection>

      <LegalSection id="quyen-so-huu-tri-tue" title="Quyền sở hữu trí tuệ">
        <h3>Sở hữu trí tuệ của chúng tôi</h3>
        <p>
          Dịch vụ Locuno, bao gồm phần mềm, công nghệ, nội dung, nhãn hiệu, logo
          và thiết kế của chúng tôi, thuộc sở hữu của Cloudjet Solutions Pte.
          Ltd. và được bảo vệ bởi luật sở hữu trí tuệ. Bạn không được sao chép,
          sửa đổi, phân phối hoặc tạo ra các tác phẩm phái sinh từ nội dung độc
          quyền của chúng tôi.
        </p>

        <h3>Giấy phép nội dung người dùng</h3>
        <p>
          Khi bạn đăng nội dung lên Dịch vụ của chúng tôi, bạn cấp cho Locuno
          giấy phép không độc quyền, miễn phí bản quyền, toàn thế giới để sử
          dụng, hiển thị, tái tạo, sửa đổi và phân phối nội dung của bạn cho mục
          đích cung cấp và cải thiện Dịch vụ của chúng tôi. Giấy phép này tiếp
          tục cho đến khi bạn xóa nội dung hoặc đóng tài khoản của mình.
        </p>

        <h3>Tôn trọng quyền của người khác</h3>
        <p>
          Bạn phải tôn trọng quyền sở hữu trí tuệ của người khác. Không đăng nội
          dung vi phạm bản quyền, nhãn hiệu hoặc các quyền sở hữu khác mà không
          có sự ủy quyền thích hợp.
        </p>

        <h3>Tuân thủ DMCA</h3>
        <p>
          Chúng tôi tuân thủ Đạo luật Bản quyền Thiên niên kỷ Kỹ thuật số (DMCA)
          và phản hồi các thông báo gỡ bỏ hợp lệ. Nếu bạn tin rằng bản quyền của
          bạn đã bị vi phạm, vui lòng liên hệ với chúng tôi với thông tin cần
          thiết như được chỉ định trong chính sách DMCA của chúng tôi.
        </p>
      </LegalSection>

      <LegalSection id="bao-mat" title="Quyền riêng tư và bảo vệ dữ liệu">
        <p>
          Quyền riêng tư của bạn rất quan trọng đối với chúng tôi. Việc thu
          thập, sử dụng và bảo vệ thông tin cá nhân của bạn được điều chỉnh bởi{" "}
          <a href="/pages/vi/privacy" className="text-blue-600 hover:underline">
            Chính sách Bảo mật
          </a>{" "}
          của chúng tôi, được kết hợp vào các Điều khoản này bằng cách tham
          chiếu.
        </p>
        <p>Các nguyên tắc bảo mật chính bao gồm:</p>
        <ul>
          <li>Minh bạch về việc thu thập và sử dụng dữ liệu</li>
          <li>
            Kiểm soát của người dùng đối với cài đặt quyền riêng tư và chia sẻ
            dữ liệu
          </li>
          <li>Bảo vệ thông tin cá nhân thông qua các biện pháp bảo mật</li>
          <li>Tuân thủ luật pháp và quy định về quyền riêng tư áp dụng</li>
          <li>Tôn trọng lựa chọn của người dùng về xử lý dữ liệu</li>
        </ul>
        <p>
          Bằng việc sử dụng Dịch vụ của chúng tôi, bạn đồng ý với việc thu thập
          và sử dụng thông tin của bạn như được mô tả trong Chính sách Bảo mật
          của chúng tôi.
        </p>
      </LegalSection>

      <LegalSection id="hoat-dong-cam" title="Hoạt động bị cấm">
        <p>Bạn bị cấm tham gia vào bất kỳ hoạt động nào sau đây:</p>

        <h3>Vi phạm kỹ thuật</h3>
        <ul>
          <li>
            Cố gắng truy cập trái phép vào hệ thống của chúng tôi hoặc tài khoản
            của người dùng khác
          </li>
          <li>
            Sử dụng công cụ tự động, bot hoặc script để truy cập hoặc tương tác
            với Dịch vụ của chúng tôi
          </li>
          <li>Kỹ thuật đảo ngược, giải mã hoặc cố gắng trích xuất mã nguồn</li>
          <li>
            Can thiệp hoặc gây gián đoạn hoạt động của Dịch vụ của chúng tôi
          </li>
          <li>Truyền virus, phần mềm độc hại hoặc mã có hại khác</li>
        </ul>

        <h3>Lạm dụng và Abuse</h3>
        <ul>
          <li>Tạo tài khoản giả hoặc mạo danh người khác</li>
          <li>Tham gia vào quấy rối, bắt nạt hoặc hành vi đe dọa</li>
          <li>
            Gửi spam cho người dùng với tin nhắn hoặc nội dung không được yêu
            cầu
          </li>
          <li>
            Sử dụng Dịch vụ của chúng tôi cho mục đích thương mại mà không có sự
            ủy quyền
          </li>
          <li>Thu thập thông tin người dùng cho mục đích trái phép</li>
        </ul>

        <h3>Hoạt động bất hợp pháp</h3>
        <ul>
          <li>
            Sử dụng Dịch vụ của chúng tôi để tạo điều kiện cho các giao dịch
            hoặc hoạt động bất hợp pháp
          </li>
          <li>Đăng nội dung vi phạm luật pháp hoặc quy định áp dụng</li>
          <li>Vi phạm quyền sở hữu trí tuệ</li>
          <li>Vi phạm quyền riêng tư hoặc luật bảo vệ dữ liệu áp dụng</li>
        </ul>
      </LegalSection>

      <LegalSection id="cham-dut-tai-khoan" title="Chấm dứt tài khoản">
        <h3>Chấm dứt bởi bạn</h3>
        <p>
          Bạn có thể chấm dứt tài khoản của mình bất cứ lúc nào bằng cách tuân
          theo quy trình xóa tài khoản trong cài đặt tài khoản của bạn. Sau khi
          chấm dứt, quyền truy cập của bạn vào Dịch vụ sẽ bị vô hiệu hóa, và dữ
          liệu tài khoản của bạn sẽ được xử lý theo Chính sách Bảo mật của chúng
          tôi.
        </p>

        <h3>Chấm dứt bởi chúng tôi</h3>
        <p>
          Chúng tôi có thể tạm ngừng hoặc chấm dứt tài khoản của bạn nếu bạn:
        </p>
        <ul>
          <li>
            Vi phạm các Điều khoản này hoặc hướng dẫn cộng đồng của chúng tôi
          </li>
          <li>Tham gia vào hoạt động bất hợp pháp hoặc có hại</li>
          <li>Tạo nhiều tài khoản hoặc cố gắng lách qua các hạn chế</li>
          <li>Không phản hồi yêu cầu xác minh hoặc thông tin bổ sung</li>
          <li>Không hoạt động trong thời gian dài</li>
        </ul>

        <h3>Hiệu lực của việc chấm dứt</h3>
        <p>
          Sau khi chấm dứt tài khoản của bạn, quyền sử dụng Dịch vụ của bạn sẽ
          chấm dứt ngay lập tức. Chúng tôi có thể giữ lại một số thông tin theo
          yêu cầu của pháp luật hoặc cho mục đích kinh doanh hợp pháp. Các điều
          khoản của Điều khoản này mà theo bản chất nên tồn tại sau khi chấm dứt
          sẽ vẫn có hiệu lực.
        </p>
      </LegalSection>

      <LegalSection
        id="tuyen-bo-va-han-che"
        title="Tuyên bố và hạn chế trách nhiệm"
      >
        <p>
          Dịch vụ được cung cấp "như hiện tại" và "như có sẵn." Chúng tôi không
          đảm bảo dịch vụ không gián đoạn, không lỗi hoặc hoàn toàn an toàn.
        </p>

        <h3>Tuyên bố về Mạng lưới An toàn Cá nhân</h3>
        <p>
          <strong>TUYÊN BỐ QUAN TRỌNG:</strong> Cloudjet Solutions Pte. Ltd.
          tuyên bố rõ ràng không chịu bất kỳ trách nhiệm nào đối với các tình
          huống khẩn cấp hoặc bất kỳ kết quả nào liên quan đến việc sử dụng tính
          năng SOS. Các tính năng SOS và dựa trên vị trí của chúng tôi được cung
          cấp chỉ như một công cụ mạng lưới an toàn cá nhân ngang hàng và KHÔNG
          được dự định như, và không hoạt động như, dịch vụ phản ứng khẩn cấp.
        </p>
        <ul>
          <li>
            <strong>Chỉ là Mạng lưới Ngang hàng:</strong> Tính năng SOS chỉ kết
            nối bạn với các liên hệ cá nhân được chọn trước (Người phản ứng)
            trong mạng lưới Locuno. Chúng tôi không kết nối, tích hợp hoặc
            truyền dữ liệu đến bất kỳ dịch vụ khẩn cấp công cộng nào
          </li>
          <li>
            <strong>Không Đảm bảo Phản ứng:</strong> Chúng tôi không đảm bảo
            rằng Người phản ứng của bạn sẽ nhận được cảnh báo, phản ứng hoặc
            cung cấp hỗ trợ
          </li>
          <li>
            <strong>Trách nhiệm Người dùng:</strong> Người dùng vẫn chịu trách
            nhiệm duy nhất trong việc liên hệ trực tiếp với các dịch vụ khẩn cấp
            công cộng (911, 112, v.v.) cho các tình huống đe dọa tính mạng
          </li>
          <li>
            <strong>Giới hạn Kỹ thuật:</strong> Tính năng SOS có thể thất bại do
            các vấn đề kỹ thuật, vấn đề mạng, giới hạn thiết bị hoặc nếu Người
            phản ứng của bạn không có ứng dụng được cài đặt hoặc kích hoạt
          </li>
        </ul>

        <h3>Tuyên bố về Dịch vụ Định vị</h3>
        <p>
          Các tính năng dựa trên vị trí được cung cấp để giúp mạng lưới cá nhân
          của bạn (Người phản ứng) xác định vị trí của bạn. Chúng tôi không đảm
          bảo:
        </p>
        <ul>
          <li>Độ chính xác của dữ liệu vị trí</li>
          <li>Tính khả dụng của dịch vụ định vị</li>
          <li>Truyền thành công thông tin vị trí đến Người phản ứng của bạn</li>
          <li>Người phản ứng của bạn sẽ nhận hoặc có thể xem dữ liệu vị trí</li>
        </ul>

        <h3>Giới hạn Trách nhiệm</h3>
        <p>
          Trong phạm vi tối đa được pháp luật cho phép, Cloudjet Solutions Pte.
          Ltd. không chịu trách nhiệm về thiệt hại gián tiếp, ngẫu nhiên, đặc
          biệt hoặc hậu quả, bao gồm nhưng không giới hạn ở các thiệt hại phát
          sinh từ:
        </p>
        <ul>
          <li>
            Các tình huống khẩn cấp hoặc bất kỳ kết quả nào liên quan đến việc
            sử dụng tính năng SOS
          </li>
          <li>Thất bại hoặc không chính xác của dịch vụ định vị</li>
          <li>
            Hành động hoặc không hành động của Người phản ứng được chỉ định của
            bạn
          </li>
          <li>Sự dựa vào của người dùng vào tính năng SOS ngang hàng</li>
          <li>Bất kỳ thương tích cá nhân hoặc thiệt hại tài sản nào</li>
        </ul>
      </LegalSection>

      <LegalSection id="boi-thuong" title="Bồi thường">
        <p>
          Bạn đồng ý bồi thường và bảo vệ Cloudjet Solutions Pte. Ltd. khỏi các
          khiếu nại phát sinh từ việc sử dụng dịch vụ, vi phạm điều khoản, hoặc
          hành động vi phạm quyền của người khác.
        </p>
      </LegalSection>

      <LegalSection
        id="luat-ap-dung"
        title="Luật áp dụng và giải quyết tranh chấp"
      >
        <p>
          Các Điều khoản này được điều chỉnh bởi luật pháp Việt Nam. Tranh chấp
          sẽ được giải quyết tại tòa án Thành phố Hồ Chí Minh hoặc qua Trung tâm
          Trọng tài Quốc tế Việt Nam (VIAC). Khiếu nại phải được đệ trình trong
          vòng một năm.
        </p>
      </LegalSection>

      <LegalSection id="thay-doi-dieu-khoan" title="Thay đổi Điều khoản">
        <p>
          Chúng tôi có thể sửa đổi các Điều khoản này bất cứ lúc nào. Thay đổi
          quan trọng sẽ được thông báo qua email, thông báo trong ứng dụng hoặc
          website. Việc tiếp tục sử dụng sau thay đổi có nghĩa là chấp nhận điều
          khoản mới.
        </p>
      </LegalSection>

      <LegalSection id="lien-he" title="Thông tin liên hệ">
        <p>Có câu hỏi về Điều khoản Dịch vụ? Liên hệ với chúng tôi:</p>
        <div className="bg-gray-50 p-4 rounded-lg mt-4">
          <p>
            <strong>Tên công ty:</strong> CÔNG TY TNHH CLOUDJET SOLUTIONS
          </p>
          <p>
            <strong>Địa chỉ:</strong> Lầu 2, Tòa nhà F Central, 16A Lê Hồng
            Phong, Phường 12, Quận 10, TP. Hồ Chí Minh, Việt Nam
          </p>
          <p>
            <strong>Mã số thuế:</strong> 0312033924
          </p>
          <p>
            <strong>Điện thoại:</strong> 028 628 00110
          </p>
          <p>
            <strong>Email:</strong> contact@locuno.com
          </p>
          <p>
            <strong>Phòng Pháp chế:</strong> legal@locuno.com
          </p>
          <p>
            <strong>Hỗ trợ Chung:</strong> support@locuno.com
          </p>
          <p>
            <strong>Quyền riêng tư:</strong> privacy@locuno.com
          </p>
        </div>
      </LegalSection>
    </LegalPageLayout>
  );
}
